import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: block;
  box-shadow: ${({ theme }) => theme.appearance.box_shadow};
  border: 1px solid ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primary};
  overflow: hidden;
  background: ${({ theme }) => theme.colors.white_1};
  padding: 24px;
  border-radius: ${({ theme }) => theme.border_radius.lg}
    ${({ theme }) => theme.border_radius.lg} 0 0;
`;

export const StepsProgressLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
  width: 100%;
`;

export const ProgressContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
`;

export const StepCircle = styled.div<{
  $completed?: boolean;
  $current?: boolean;
}>`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${({ $current }) => ($current ? '2px' : '1px')} solid
    ${({ theme, $completed }) =>
      $completed ? theme.colors.green_high_contrast : theme.colors.grey_3};
  color: ${({ theme, $completed, $current }) =>
    $completed
      ? theme.colors.grey_2
      : $current
        ? theme.colors.grey_2
        : theme.colors.grey_3};
  background: ${({ theme, $completed }) =>
    $completed ? theme.colors.green_4 : theme.colors.white_1};
  position: relative;
  z-index: 1;
  font-weight: ${({ theme, $current }) =>
    $current ? theme.fontWeights.bold : theme.fontWeights.light};
`;

export const WarningCircle = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -10px;
  right: -10px;
  border: 1px solid;
  background: ${({ theme }) => theme.colors.red_5};
  z-index: 1;
`;

export const Connector = styled.div`
  position: absolute;
  top: 50%;
  left: 14px;
  right: 14px;
  height: 1px;
  background: ${({ theme }) => theme.colors.grey_4};
  transform: translateY(-50%);
  z-index: 0;
`;

export const ResponsiveHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const ResponsiveContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: stretch;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const ContentDetails = styled.div`
  gap: 8px;
  display: flex;
  flex-direction: column;
  flex: 1;
  height: fit-content;
  width: auto;
  text-align: left;
  align-items: flex-start;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    width: 100%;
    text-align: center;
    align-items: center;

    & > div {
      justify-content: center !important;
    }
  }
`;

export const ResponsiveLinkWrapper = styled.div`
  width: auto;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    width: 100%;
  }
`;

export const ResponsiveActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${({ theme }) => theme.spacing.sm + theme.spacing.xs}px;
  width: auto;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    width: 100%;
    align-items: center;
  }
`;

export const LinkContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    justify-content: center;
  }
`;

export const MainContentHeaderActions = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 0;
`;
